module.exports = window["MaterialUI"].GridListTile;